import * as React from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import {Breakpoint, ButtonProps, DialogActions, DialogContent, DialogContentText, IconButton} from "@mui/material";
import {Close} from "@mui/icons-material";
import Button from "@mui/material/Button";

export interface CustomModalAction {
    label: string;
    icon?: React.ReactNode;
    color?: "primary" | "secondary" | "error" | "info" | "success" | "warning";
    method?: () => void;
    props?: ButtonProps;
}

export interface CustomModalProps {
    open: boolean;
    handleClose: (action: CustomModalAction) => void;
    title: string;
    contentText?: string;
    customContent?: React.ReactNode;
    defaultAction: CustomModalAction;
    secondaryAction?: CustomModalAction;
    cancelAction: CustomModalAction;
    width?: Breakpoint | false;
}

export function CustomModal(props: CustomModalProps) {
    const {
        handleClose,
        open,
        title,
        contentText,
        customContent,
        secondaryAction,
        defaultAction,
        cancelAction,
        width
    } = props;

    const onClose = () => {
        handleClose(cancelAction);
    };

    const handleAction = (action: CustomModalAction) => {
        handleClose(action);
    };

    return (
        <Dialog onClose={onClose} open={open} fullWidth={!!width} maxWidth={width}>
            <DialogTitle sx={{mr: 6}}>{title}</DialogTitle>
            <IconButton
                aria-label="close"
                onClick={onClose}
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 12,
                    color: theme.palette.grey[500],
                })}
            >
                <Close/>
            </IconButton>
            <DialogContent dividers>
                <DialogContentText>
                    {contentText}
                </DialogContentText>
                {customContent}
            </DialogContent>
            <DialogActions>
                <Button
                    key={cancelAction.label}
                    onClick={() => handleAction(cancelAction)}
                    sx={{mr: 'auto'}}
                    startIcon={cancelAction.icon}
                    color={cancelAction.color}
                    {...cancelAction.props}
                >
                    {cancelAction.label}
                </Button>
                {secondaryAction && (
                    <Button
                        key={secondaryAction.label}
                        onClick={() => handleAction(secondaryAction)}
                        variant="outlined"
                        startIcon={secondaryAction.icon}
                        color={secondaryAction.color}
                        {...secondaryAction.props}
                    >
                        {secondaryAction.label}
                    </Button>
                )}
                <Button
                    key={defaultAction.label}
                    onClick={() => handleAction(defaultAction)}
                    variant="contained"
                    startIcon={defaultAction.icon}
                    color={defaultAction.color}
                    {...defaultAction.props}
                >
                    {defaultAction.label}
                </Button>

            </DialogActions>
        </Dialog>
    );
}
